import React from 'react'
import { Warning } from 'components/Icons'

const Restriction = ({ restrictionType, height = 100, width = 100 }) => {
  if (!restrictionType) {
    return null
  }
  return (
    <div
      style={{
        position: 'absolute',
        height: '100%',
        width: '100%',
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Warning
        stroke={'#fff'}
        style={{ width, height, marginTop: -30, opacity: 0.3 }}
      />
    </div>
  )
}

export default Restriction



// WEBPACK FOOTER //
// ./src/components/Media/File/Restriction/restriction.js